import { Component, Host, h, Prop, Event } from '@stencil/core';
import { hideFocusRingWhenUsingMouse } from '../../../../global/utils/utils';
export class DropdownOptionComponent {
  constructor() {
    /**
     * The selId from parent
     */
    this.selId = '';
    /**
     * The value of the option
     */
    this.value = '';
    /**
     * The text of the option for display
     */
    this.text = '';
    /**
     * The selected index of the option, passed in from parent
     */
    this.selectedIndex = -1;
    /**
     * The hovered index of the option for display, passed in from parent
     */
    this.hoveredIndex = -1;
    /**
     *  Flag to set if the option is selected, passed in from the current component
     */
    this.selected = false;
  }
  handleOptionClick(index) {
    this.dropdownOptionSelected.emit(index);
  }
  componentDidLoad() {
    hideFocusRingWhenUsingMouse(this.listItem);
  }
  /**
   * Create HTML representation of component DOM and return this
   for output to the browser DOM
   */
  render() {
    return (h(Host, null,
      h("li", { ref: (el) => (this.listItem = el), "aria-selected": this.selectedIndex === this.index ? 'true' : 'false', "aria-labelledby": `${this.selId}-option`, role: "option", onMouseDown: () => this.handleOptionClick(this.index), class: {
          'agl-ds-dropdownbox-option': true,
          'agl-ds-dropdownbox-option--hovered': this.hoveredIndex === this.index,
          'agl-ds-dropdownbox-option--selected': this.selectedIndex === this.index
        }, id: `${this.selId}__option--${this.index}`, "aria-posinset": this.index + 1, "aria-setsize": this.setSize, value: this.value },
        h("span", { class: "agl-ds-dropdownbox-option__text" }, this.text))));
  }
  static get is() { return "agl-ds-dropdown-option"; }
  static get encapsulation() { return "scoped"; }
  static get originalStyleUrls() { return {
    "$": ["dropdownoption.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["dropdownoption.component.css"]
  }; }
  static get properties() { return {
    "selId": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The selId from parent"
      },
      "attribute": "sel-id",
      "reflect": false,
      "defaultValue": "''"
    },
    "value": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The value of the option"
      },
      "attribute": "value",
      "reflect": false,
      "defaultValue": "''"
    },
    "text": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The text of the option for display"
      },
      "attribute": "text",
      "reflect": false,
      "defaultValue": "''"
    },
    "index": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The index of the option in options list"
      },
      "attribute": "index",
      "reflect": false
    },
    "selectedIndex": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The selected index of the option, passed in from parent"
      },
      "attribute": "selected-index",
      "reflect": false,
      "defaultValue": "-1"
    },
    "hoveredIndex": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The hovered index of the option for display, passed in from parent"
      },
      "attribute": "hovered-index",
      "reflect": false,
      "defaultValue": "-1"
    },
    "selected": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Flag to set if the option is selected, passed in from the current component"
      },
      "attribute": "selected",
      "reflect": false,
      "defaultValue": "false"
    },
    "setSize": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The length of option elements"
      },
      "attribute": "set-size",
      "reflect": false
    }
  }; }
  static get events() { return [{
      "method": "dropdownOptionSelected",
      "name": "dropdownOptionSelected",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Fires when an option is selected"
      },
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      }
    }]; }
}
